import { render, staticRenderFns } from "./GratificationRecharges.vue?vue&type=template&id=2604eafa&scoped=true&"
import script from "./GratificationRecharges.vue?vue&type=script&lang=js&"
export * from "./GratificationRecharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2604eafa",
  null
  
)

export default component.exports